import { type ILandUseType, LandUseType } from '@app/land-hold/land-use-type/models/LandUseType';
import { useFetchInertiaPageJson } from '@shared/composables/useFetchInertiaPageJson';
import { useRoute } from '@shared/composables/useRoute';
import type { ListResponse } from '@shared/types/ApiResponse';
import type { Ref } from 'vue';

export function useLanduseTypes(): { landuseTypes: Ref<ILandUseType[]>; fetchingLanduseTypes: Ref<boolean>; error: Ref<string | null> } {
    const landuseTypes: Ref<ILandUseType[]> = ref([]);
    const fetchingLanduseTypes = ref(true);
    const error = ref<string | null>(null);

    useFetchInertiaPageJson<ListResponse<ILandUseType>>(useRoute().build(LandUseType.routes().index), 'appSection@landUse::IndexLandUseTypesPage', [], { params: { limit: 0 } })
        .then(({ data: page }) => {
            landuseTypes.value = (page.props as ListResponse<ILandUseType>).data;
        })
        .catch(() => {
            error.value = 'Failed to load vegetation types. Please reload the page.';
        })
        .finally(() => {
            fetchingLanduseTypes.value = false;
        });

    return { landuseTypes, fetchingLanduseTypes, error };
}
